import { PackingSlip, VendorPurchaseOrder } from "../components";
import { QuoteDocument } from "../components/QuoteDocument";
import { CustomerQuoteDocument } from "../components/CustomerQuoteDocument";

export const TEMPLATES = [
  {
    id: 1,
    label: "Packing Slip",
    Template: (rest) => <PackingSlip {...rest} />,
  },
  {
    id: 2,
    label: "Packing Slip - No Pricing",
    Template: (rest) => <PackingSlip hidePrice {...rest} />,
  },
  {
    id: 3,
    label: "Packing Slip - No Details",
    Template: (rest) => <PackingSlip hideBoxes {...rest} />,
  },
  {
    id: 4,
    label: "Packing Slip - No Details/Pricing",
    Template: (rest) => <PackingSlip hideBoxes hidePrice {...rest} />,
  },
  {
    id: 5,
    label: "Packing Slip - Serialization",
    Template: (rest) => (
      <PackingSlip hideBoxes includeSerialization {...rest} />
    ),
  },
];

export const PO_TEMPLATES = [
  {
    id: 1,
    label: "Vendor Purchase Order",
    Template: (rest) => <VendorPurchaseOrder {...rest} />,
  },
];

export const QUOTE_TEMPLATES = [
  {
    id: 1,
    label: "Quote - Internal",
    Template: (rest) => <QuoteDocument {...rest} />,
  },
  {
    id: 2,
    label: "Quote - Customer",
    Template: (rest) => <CustomerQuoteDocument {...rest} />,
  },
];
